import { ReactNode } from "react";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 64px;
  padding: 16px;
  border-top: 1px solid var(--color-primary-200);
  order: 2;
`;

type Props = {
  children: ReactNode;
  className?: string;
};

export const Footer = ({ children, className }: Props): JSX.Element => (
  <Container className={className}>{children}</Container>
);
